import { inject, Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { distinctUntilChanged, map, Observable, pipe } from 'rxjs';

const uniqueMatches = () =>
  pipe(
    map((breakpoint: BreakpointState) => breakpoint.matches),
    distinctUntilChanged(),
  );

@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  private breakpointObserver = inject(BreakpointObserver);

  isDesktopPlus: Observable<BreakpointState> = this.breakpointObserver.observe(
    '(min-width: 1200px)',
  );

  isTabletPlus: Observable<BreakpointState> =
    this.breakpointObserver.observe('(min-width: 768px)');

  isDesktopPlusUnique$ = this.isDesktopPlus.pipe(uniqueMatches());
  isTabletPlusUnique$ = this.isTabletPlus.pipe(uniqueMatches());
}
